import InfoPage, { linkClass } from "@/components/InfoPage";
import { INSTAGRAM_HANDLE, INSTAGRAM_URL } from "@/lib/site";

// Copy is Axel's own words (1 Nov 2026). Keep it exactly as written.
export default function AboutPage() {
  return (
    <InfoPage title="About AERWEAR" seoTitle="About | AERWEAR" description="AERWEAR was built for the ones who never settled for second. Born from racing culture and a refusal to blend in." testid="about-page">
      <p className="text-[17px] sm:text-lg text-[#F2F0EB]">AERWEAR was built for the ones who never settled for second. Born from racing culture and a refusal to blend in, every piece is designed for people who go over the top, on purpose. We don't make clothes for the crowd. We make them for the ones who leave it behind.</p>
      <p>How it works: most pieces are made to order. Your order ships in about 4 weeks, then arrives in 2 to 7 business days. Shipping in the US is free.</p>
      <p>Join the club for new drops and early news at the bottom of any page. Follow us on Instagram <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className={linkClass}>{INSTAGRAM_HANDLE}</a>.</p>
    </InfoPage>
  );
}
